import AbstractError from './AbstractError';
import { SIM_CARD_MARKET_ERROR } from '../../config/errorCodes';

/**
 * Thrown if the user tried to activate a sim card with a wrong market.
 */
class SimCardMarketError extends AbstractError {
  constructor() {
    super(SIM_CARD_MARKET_ERROR);
  }
}

export default SimCardMarketError;
